// extracted by mini-css-extract-plugin
module.exports = {"title":"BackSectionV2_title__3iSFL","arrow":"BackSectionV2_arrow__5l5Bn"};